// Bildirim türü → ikon + renk. Başlık/metin BE'den (zaten Türkçe) gelir; meta
// yalnız görsel ayrım (ikon + anlamsal renk) sağlar. Bilinmeyen tür varsayılan
// zil ikonuyla karşılanır (FE, BE yeni tür eklerse kırılmaz).

import {
  Bell,
  CircleCheck,
  CircleX,
  Inbox,
  MessageSquareText,
  Rocket,
  type LucideIcon,
} from 'lucide-react';
import type { NotificationType } from './types';

export interface NotificationMeta {
  Icon: LucideIcon;
  /** Anlamsal renk (CSS değişkeni). */
  color: string;
}

const META: Record<NotificationType, NotificationMeta> = {
  WorkflowSubmitted: { Icon: Inbox, color: 'var(--ds-warning)' },
  WorkflowApproved: { Icon: CircleCheck, color: 'var(--ds-success)' },
  WorkflowRejected: { Icon: CircleX, color: 'var(--ds-danger)' },
  WorkflowPublished: { Icon: Rocket, color: 'var(--ds-brand)' },
  FormSubmitted: { Icon: MessageSquareText, color: 'var(--ds-info)' },
};

const FALLBACK: NotificationMeta = { Icon: Bell, color: 'var(--ds-text-secondary)' };

export function notificationMeta(type: string): NotificationMeta {
  return (META as Record<string, NotificationMeta>)[type] ?? FALLBACK;
}
